<template>
    <div class="row mb-8">
        <div class="col d-flex justify-content-start">
            <span class="title">{{ $t('Delivery.Add') }}</span>
        </div>
        <div class="col d-flex gap-2 justify-content-end">
            <genericBtnComponent
                :disabled="loader"
                :ClickFun="createDeliveryCompany"
                svg="1"
                :Title="$t('Delivery.save')"
                :loader="loader"
            />
        </div>
    </div>
    <v-card elevation="0">
        <div class="row ma-4">
            <div class="col-4">
                <v-card-title>{{ $t('Delivery.companyName') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="BrandName"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.companyName') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.BrandName }}</span>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.description') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="Description"
                    maxlength="100"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.description') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.Description }}</span>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Adresse') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="Address"
                    maxlength="100"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Adresse') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.Address }}</span>
            </div>
        </div>

        <div class="row ma-4">
            <div class="col-4">
                <v-card-title>{{ $t('Delivery.email') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="EmailAddress"
                    maxlength="100"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.email') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.EmailAddress }}</span>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Phone') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="Phone"
                    maxlength="15"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Phone') })"
                    variant="outlined"
                ></v-text-field>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.TaxNumber') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="TaxIdentificationNumber"
                    maxlength="30"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.TaxNumber') })"
                    variant="outlined"
                ></v-text-field>
            </div>
        </div>

        <div class="row ma-4">
            <div class="col-4">
                <v-card-title>{{ $t('Delivery.password') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="Password"
                    type="password"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.password') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.Password }}</span>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Confrmpassword') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="ConfirmPassword"
                    type="password"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Confrmpassword') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.Password }}</span>
            </div>

         
        </div>
        <div class="col-4">
                <v-card-title>{{ $t('Delivery.Logo') }}</v-card-title>
                <uploadLogo :API="2" @addLogo="setLogo" :namelogo="logoImage" />
            </div>
    </v-card>
</template>

<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import uploadLogo from '@/genericComponent/uploadLogo.vue'
import { createDeliveryCompany  } from "@/api/index";
export default {
    components: {
        genericBtnComponent , uploadLogo , 
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.Brands');
         
    },
    data: () => ({
        BrandName: "",
        Description: "",
        EmailAddress: "",
        Phone: "",
        Address: "",
        TaxIdentificationNumber: "",
        Password: "",
        ConfirmPassword: "",
        logoImage: null,
        loader: false,
        msg: {},
}),
   methods : {
    async createDeliveryCompany() {
            this.loader = true;
            try {
                // Construction de FormData
                const formData = new FormData();
                formData.append('companyName', this.BrandName);
                formData.append('companyDescription', this.Description);
                formData.append('EmailAddress', this.EmailAddress);
                formData.append('Phone', this.Phone || '');
                formData.append('Address', this.Address);
                formData.append('TaxIdentificationNumber', this.TaxIdentificationNumber || '');
                formData.append('Password', this.Password);
                formData.append('ConfirmPassword', this.ConfirmPassword);

                // Gestion du logo s'il est défini
                if (this.logoImage) {
                    formData.append('companyLogo', this.logoImage);
                }

                // Appel de l’API
                await createDeliveryCompany(formData);

                // Redirection et notification de succès
                this.$router.push({ path: "/DeliveriesList" });
                this.$emit("snackbarSuccess", this.$t("Delivery.companyCreated"));
            } catch (error) {
                console.error("Error creating delivery company:", error);
                this.$emit("snackbarError", this.$t("Delivery.companyCreationFailed"));
            } finally {
                this.loader = false;
            }
        },
        setLogo(file) {
            this.logoImage = file;
        },
   
   
    navigateToList() {
            this.$router.push({ path: "/BrandsMenu" });
        },

   },
   computed : {
    

   }
    
};
</script>
<style scoped>
.title {
    margin-top: auto;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    padding-left: 0;
    margin-top: 0;
    padding-top: 0;
}



.v-autocomplete {
    margin-left: 12px !important;
}

.border-bottom {
    border-bottom: 1px solid #ddd;
}

.border-right {
    border: 1px solid #ddd;
    text-align: center;
    border-style: dotted;
    padding: 2px 4px;
}

.totals {
    margin-top: 20px;
    /* font-weight: bold; */
}

.rounded-table {
    border-radius: 10px;
}

.totals p {
    margin: 5px 0;
}

.align-right {
    padding-right: 85px;
    text-align: right;
    position: relative;
}

.align-devise {
    float: right;
    margin-left: -16px;
}

.custom-divider {
    border-top: 1px solid;
    border-color: currentColor;
}

.add-line {
    display: inline-block;
    color: blue;
    cursor: pointer;
    margin-top: 10px;
}

.add-icon {
    color: #0000FF;
}

.customWarningHint {
    color: #F25C5C;
    padding: 12px 0px 12px 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 0px;
    display: block;
    text-align: left;
    text-wrap: nowrap;
}
</style>